// 移动端校园招聘
import React from 'react'
import styles from './index.module.scss'
import defaultSetting from '@/setting'
import {getPositionsNumlApi} from '@/api'
import {getUrlParams} from "@/utils/util"

const banner = require('@/assets/mobileImages/campus/banner.png')
const list_01 = require("@/assets/mobileImages/campus/list_01.png")
const list_02 = require("@/assets/mobileImages/campus/list_02.png")
const list_03 = require("@/assets/mobileImages/campus/list_03.png")
const list_04 = require("@/assets/mobileImages/campus/list_04.png")
const list_05 = require("@/assets/mobileImages/campus/list_05.png")

class MobileCampus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    imgUrl: list_01,
                    toUrl: `/${defaultSetting.suiteKeyMc}/mc/position/campus?projectCode=202301&orgCode=${getUrlParams().orgCode}`,
                    title: "应届生招聘",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: list_02,
                    toUrl: `/${defaultSetting.suiteKeyMc}/mc/position/intern?projectCode=100301&orgCode=${getUrlParams().orgCode}`,
                    title: "实习生",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: list_03,
                    toUrl: ``,
                    title: "红旗学院",
                    content: '敬请期待'
                },
                {
                    imgUrl: list_04,
                    toUrl: ``,
                    title: "蓝领校招",
                    content: '敬请期待'
                },
                {
                    imgUrl: list_05,
                    toUrl: ``,
                    title: "校招转推荐",
                    content: '敬请期待'
                },
            ],
            positionsCode: ['202301', '100301'],
            positionsNum: [],
        }
    }

    componentWillMount() {
        if (defaultSetting.grayscale) {
            document.querySelector('html').classList.add('grayscale');
        }
    }

    componentDidMount() {
        const {orgCode} = getUrlParams();

        getPositionsNumlApi({recruitType: 1, curSearchEle: 'project', orgCode}).then(res => {
            let {positionsCode, positionsNum} = this.state;
            const {projectList} = res.data;

            for (let j = 0; j < projectList.length; j++) {
                if (positionsCode[0] === projectList[j].code) {
                    positionsNum[0] = projectList[j].positionsNum;
                }
            }

            this.setState({
                positionsNum
            })
        })

        getPositionsNumlApi({recruitType: 12, curSearchEle: 'project', orgCode}).then(res => {
            let {positionsCode, positionsNum} = this.state;
            const {projectList} = res.data;

            for (let j = 0; j < projectList.length; j++) {
                if (positionsCode[1] === projectList[j].code) {
                    positionsNum[1] = projectList[j].positionsNum;
                }
            }

            this.setState({
                positionsNum
            })
        })

        document.querySelector('.footer').style.display = 'none';
    }

    render() {
        const {list, positionsNum} = this.state;
        return (
            <>
                <main className={styles.mobileCampus}>
                    <div className="bannerCon">
                        <img src={banner} alt="banner"/>
                    </div>
                    <div className="listCon">
                        {
                            list.map((item, index) => (
                                <a className="lists" key={index} href={item.toUrl ? item.toUrl : 'javascript:void(0);'}>
                                    <img src={item.imgUrl} alt="pic"/>
                                    <div className="content">
                                        <p>{item.title}</p>
                                        <p>{item.toUrl ? (positionsNum[index] || 0) : ''}{item.content}</p>
                                    </div>
                                </a>
                            ))
                        }
                    </div>
                </main>
            </>
        );
    }
}

export default MobileCampus;